import React from 'react';
import { useTranslation } from 'react-i18next';
import { sendTrackingInfo } from '@panel/commons';
import SimpleTooltip from '@panel/commons/lib/Tooltip/SimpleTooltip';
import { BulkActionIcon, BulkActionIconContainer, BulkActionContainer, BulkActionText } from '../styles';

const Finish = ({ postings, setBulkActionsModals, bulkActionsModals, device }) => {
  const { t } = useTranslation();
  const offlineStates = ['DRAFT', 'OFFLINE', 'DELETED'];

  const finishAvailable =
    postings &&
    postings.some(p => p.checked) &&
    !postings.some(p => p.checked && offlineStates.some(state => state === p.stateAndDates[0].status));

  const postingsToFinish = finishAvailable
    ? postings.reduce((finishArray, currentPosting) => {
        if (currentPosting.checked && !currentPosting.postingFull) finishArray.push(currentPosting.postingId);
        return finishArray;
      }, [])
    : [];

  const paidPlansIncluded =
    postingsToFinish.length > 0 && postings.some(p => p.checked && !p.publicationPlan.includes('FREE'));

  if (finishAvailable) {
    return (
      <BulkActionContainer
        onClick={() => {
          setBulkActionsModals({
            ...bulkActionsModals,
            finish: { open: true, postingList: postingsToFinish, paidPlansIncluded }
          });
          sendTrackingInfo('Panel', 'Mis avisos', 'Bulk-Finalizar');
        }}
        className='insideSelector'
      >
        <SimpleTooltip isMobile={device === 'tablet'} position='top-center' text={t('panel.bar.select.actions.finish')}>
          <BulkActionIconContainer device={device}>
            <BulkActionIcon action='finish' />
          </BulkActionIconContainer>
        </SimpleTooltip>
        {device === 'tablet' && <BulkActionText>{t('panel.bar.select.actions.finish')}</BulkActionText>}
      </BulkActionContainer>
    );
  }
  return null;
};

export default Finish;
